import {
  isLeasingProposalAvailable,
  isUlf24LeasingProposalAvailable,
  isCreditmarketProposalAvailable,
  isCreditmarketNotClearedProposalAvailable,
  isCommonLeasingProposalAvailable,
} from './myAuto';

export {
  isLeasingProposalAvailable,
  isUlf24LeasingProposalAvailable,
  isCreditmarketProposalAvailable,
  isCreditmarketNotClearedProposalAvailable,
  isCommonLeasingProposalAvailable,
} from './myAuto';

export const isAnyLeasingAvailable = advertData => {
  const isAvailable = isCommonLeasingProposalAvailable(advertData);
  return (
    isAvailable &&
    (isLeasingProposalAvailable(advertData) ||
      isUlf24LeasingProposalAvailable(advertData) ||
      isCreditmarketNotClearedProposalAvailable(advertData) ||
      isCreditmarketProposalAvailable(advertData))
  );
};

function getLeasingCreditmarketTitle(advertData, t) {
  const PRICE_UAH = advertData.is_not_cleared ? '300 000' : '140 000';
  const prefix = t('Профинансируем это авто');
  const title = `${PRICE_UAH} грн.`;
  return { title, prefix };
}

function getLeasingRegularTitle(leasingParams, t) {
  let price = 0;
  if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
    price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
  } else if (leasingParams && leasingParams.extendedParams) {
    price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
  }

  const symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
  const moth = t('мес');
  const title = `${price} ${symbol}/${moth}`;
  return { title, prefix: '' };
}

export const getLeasingTitle = (advertData, leasingParams, t) => {
  if (
    isCreditmarketNotClearedProposalAvailable(advertData) ||
    isCreditmarketProposalAvailable(advertData)
  ) {
    return getLeasingCreditmarketTitle(advertData, t);
  }
  if (isUlf24LeasingProposalAvailable(advertData) || isLeasingProposalAvailable(advertData)) {
    return getLeasingRegularTitle(leasingParams, t);
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/leasing.js